//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProjectActionsContainerSimple from '@/components/Projects/NewProjectSteps/shared/ProjectActionsContainerSimple.vue'
import handleErrorMixin from '@/mixins/handleErrorMixin'
import SupervisorSelect from '~/components/Projects/Detail/Tabs/Collaborators/Table/SupervisorSelect.vue'
import Button from '~/components/Shared/Button'
import PROJECT_ROLES from '~/constants/project-roles'
import ProjectModalAddUsers from '~/components/Projects/NewProjectSteps/shared/ProjectModalAddUsers.vue'
import InputFile from '~/components/Shared/Form/InputFile.vue'
import ExampleUploadFile from '~/components/Shared/Form/ExampleUploadFile.vue'

export default {
  name: 'MassiveImportUserModal',
  components: {
    Button,
    ProjectActionsContainerSimple,
    ProjectModalAddUsers,
    InputFile,
    ExampleUploadFile,
    SupervisorSelect,
  },
  mixins: [handleErrorMixin],
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    projectId: {
      type: Number,
      required: true,
    },
    supervisors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: this.value,
      file: null,
      message: null,
      supervisor: null,
    }
  },
  computed: {
    isEnableSubmit() {
      return !!this.file && !!this.supervisor
    },
    supervisorsFormatted() {
      return this.supervisors.map((supervisor) => ({
        value: supervisor.id,
        names: `${supervisor.names} ${supervisor.lastnames}`,
      }))
    },
  },
  watch: {
    value() {
      this.active = this.value
      if (!this.value) {
        this.reset()
      }
    },
    active(newValue) {
      this.$emit('input', newValue)
    },
  },
  methods: {
    reset() {
      this.file = null
      this.supervisor = null
    },

    async massValidateUsers({ file, message }) {
      try {
        this.$store.commit('loading', true)
        const formData = new FormData()
        formData.append('massive', file)
        formData.append('message', message)
        formData.append('project_id', this.projectId)
        formData.append('user_origin', 'relink')
        formData.append('project_role', PROJECT_ROLES.COLLABORATOR)
        const response = await this.$repository.invitation.massValidateCollaborators(
          formData
        )
        this.file = null
        this.$emit('massive-users-details', {
          collaborators: response,
          supervisorId: this.supervisor?.value,
        })
      } catch (e) {
        this.handleError(e, e.response?.data?.error || 'Ocurrió un error')
      } finally {
        this.$store.commit('loading', false)
      }
    },
    handleNewSupervisor() {
      this.reset()
      this.$emit('add-new-supervisor')
      this.active = false
    },
  },
}
